let obj = {
  fmtGender: val => ["男", "女", "未知"][val],
  test: function (val) {
    return ["未完成", "已完成"][val];
  },
};

export default obj;
